export const BETA = 'beta';
export const PRODUCTION = 'production';
